import React, { useState } from "react";
import { Trash2 } from "lucide-react";
import {
    AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
    AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "./ui/alert-dialog";

// Trash button that asks for confirmation before running onConfirm.
export const ConfirmDelete = ({ onConfirm, testid, title = "Confirmar exclusão", description = "Esta ação não pode ser desfeita.", className = "" }) => {
    const [open, setOpen] = useState(false);
    return (
        <>
            <button onClick={() => setOpen(true)} data-testid={testid} className={`rounded-xl border border-border p-2 text-muted-foreground transition-colors hover:bg-expense/10 hover:text-expense ${className}`}>
                <Trash2 className="h-4 w-4" />
            </button>
            <AlertDialog open={open} onOpenChange={setOpen}>
                <AlertDialogContent className="rounded-2xl">
                    <AlertDialogHeader>
                        <AlertDialogTitle className="font-heading">{title}</AlertDialogTitle>
                        <AlertDialogDescription>{description}</AlertDialogDescription>
                    </AlertDialogHeader>
                    <AlertDialogFooter>
                        <AlertDialogCancel className="rounded-full" data-testid={`${testid}-cancel`}>Cancelar</AlertDialogCancel>
                        <AlertDialogAction className="rounded-full bg-expense hover:bg-expense/90" data-testid={`${testid}-confirm`} onClick={() => { setOpen(false); onConfirm(); }}>
                            Excluir
                        </AlertDialogAction>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialog>
        </>
    );
};
